// Résout l'image de fond active à partir du noeud racine `campaignMap/{campaignUid}`.
// Gère aussi l'ancien format (une seule carte à plat) pour rétro-compatibilité
// tant que la migration MJ n'a pas eu lieu.
export const resolveActiveMap = (root, campaignUid) => {
  if (!root) return null;
  // Nouveau format : plusieurs images sous `maps/`, une active via `activeMapId`
  if (root.activeMapId && root.maps && root.maps[root.activeMapId]) {
    const m = root.maps[root.activeMapId];
    return {
      mapId: root.activeMapId,
      url: m.url || '',
      name: m.name || '',
      path: `campaignMap/${campaignUid}/maps/${root.activeMapId}`,
      pins: m.pins,
    };
  }
  // Ancien format : url + pins/playerPins/drawings à la racine
  if (root.url) {
    return {
      mapId: null,
      url: root.url,
      name: '',
      path: `campaignMap/${campaignUid}`,
      pins: root.pins,
    };
  }
  return null;
};

export const MAX_MAPS = 10;
